module.exports = __webpack_public_path__ + "static/media/avatar.3122abf4.jpg";